import { DestroyRef, inject, Service } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivationEnd, NavigationEnd, Router } from '@angular/router';
import { NavigationKeys, NavigationStore } from '@workspace/ng-data-access';
import { filter, map, tap } from 'rxjs';

@Service()
export class NavigationTrackerAuraService {
  private readonly navigationStore = inject(NavigationStore);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.router.events
      .pipe(
        filter((e): e is ActivationEnd => e instanceof ActivationEnd),
        map((event) => event.snapshot.data['navigation']?.key as NavigationKeys | undefined),
        filter((key): key is NavigationKeys => Boolean(key)),
        tap((key) => {
          this.navigationStore.updateNavigationKey(key);
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();

    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        tap((event) => {
          if (this.navigationStore.currentKey() !== NavigationKeys.PUBLIC) {
            return;
          }
          const path = event.urlAfterRedirects.split('?')[0].split('#')[0];
          if (path === '/pro' || path.startsWith('/pro/')) {
            this.navigationStore.setPublicAudience('pro');
          } else if (path === '/' || path === '' || path === '/home') {
            this.navigationStore.setPublicAudience('owner');
          }
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
